import styled from 'styled-components';
import { variables } from 'components/theme';
import {
  itemMainBackgroundColor,
  itemAsideBackgroundColor,
  itemTextColor,
  itemTitleColor,
  tabsTextColor,
  carouselDateBackgroundColor
} from 'utils/theme';

const displayFlex = {
  display: 'flex',
  spaceBetween: 'space-between'
};

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;

  p {
    ${variables.fonts.openSansSemiBold};
  }
`;

export const Header = styled.div`
  background: ${itemAsideBackgroundColor};
  padding: 7px 14px;

  h3 {
    color: ${itemTitleColor};
  }

  p,
  h5 {
    color: ${itemTextColor};
    ${variables.fonts.openSansSemiBold};
  }
`;

export const Tickets = styled.div`
  color: ${itemTextColor};
  padding: 21px 14px;
`;

export const HeaderImage = styled.div`
  margin: 21px 0;
  min-height: 300px;
`;

export const HeaderContent = styled.div`
  margin: 21px 0;
`;

export const Aside = styled.aside`
  flex: 1.5;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${itemAsideBackgroundColor};
  border: 1px solid ${itemAsideBackgroundColor};
  padding: 105px 0;

  .container {
    width: 470px;
    margin-right: auto;
  }

  .event-description-item {
    margin: 8px 0;
  }
`;

export const MainImage = styled.div`
  cursor: pointer;
  width: 470px;
  height: 470px;
  background: #707070 url(${({ src }) => src}) no-repeat center center/cover;
  margin-bottom: 21px;
`;

export const ShowCase = styled.div`
  display: flex;

  img {
    max-width: calc(25% - 21px);
    margin-right: 28px;
  }

  img:last-child {
    margin-right: 0px;
  }
`;

export const Main = styled.main`
  flex: 2;
  padding: 98px 0 98px 63px;
  border-bottom: 1px solid rgba(112, 112, 112, 0.07);
  background: ${itemMainBackgroundColor};
  color: ${itemTextColor};

  h1,
  h2 {
    color: ${itemTitleColor};
  }

  .description a {
    color: ${variables.colors.blue1};
    text-decoration: none;
  }

  .subtotal {
    margin-bottom: 0;
  }

  .tickets,
  .description {
    margin: 21px 0;
  }
`;

export const Details = styled.div`
  margin: 21px 0;

  a {
    color: ${variables.colors.blue1};
    text-decoration: none;
  }

  svg,
  img {
    fill: ${itemTextColor};
    vertical-align: middle;
    margin-right: 7px;
  }

  b {
    color: red;
  }
`;

export const Currency = styled.div`
  .css-8n9vvk-placeholder {
    color: ${variables.colors.grey4};
    font-weight: 600;
  }
`;

export const Title = styled.div`
  display: flex;

  h1 {
    font-size: 2.25em;
    ${variables.fonts.openSansSemiBold};
    ${variables.colors.grey16};
  }
`;

export const Badge = styled.div`
  padding: 7px 14px;
  text-align: center;
  border-radius: 8px;
  border: 1px solid ${carouselDateBackgroundColor};
  background-color: ${carouselDateBackgroundColor};
  color: ${itemTitleColor};
  height: 99px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 658px) {
    margin-right: 14px;
  }

  @media (min-width: 658px) {
    margin-right: 21px;
  }

  p {
    font-size: 14px;
  }

  .day {
    color: ${variables.colors.brown2};
  }

  .date {
    font-size: 28px;
    line-height: 1.2;
  }
`;

export const MoreEvents = styled.div`
  padding: 35px 0;
  font-weight: 600;

  a {
    color: inherit;
  }
`;

export const MoreEventsDescription = styled.p`
  color: ${itemTitleColor};
  padding-bottom: 7px;
  border-bottom: 3px solid rgb(112, 112, 112, 0.07);

  a {
    color: ${variables.colors.blue1};
    text-decoration: none;
  }
`;

export const EventShowcase = styled.div`
  display: flex;
  border-top: 1px solid rgba(112, 112, 112, 0.07);

  & > div {
    max-width: calc(25% - 21px);
    margin-right: 28px;
  }

  & > div {
    margin-right: 0px;
  }
`;

export const TabsWrapper = styled.div`
  .react-tabs__tab-list {
    margin-bottom: 21px;
    border-bottom: 1px solid rgba(112, 112, 112, 0.07);
    display: ${displayFlex.display};

    li:first-child {
      margin-right: 42px;
    }

    button {
      ${variables.fonts.openSansSemiBold}
      border: none;
      background: transparent;
      color: inherit;
    }

    p {
      ${variables.fonts.openSansSemiBold}
    }
  }

  .react-tabs__tab {
    color: #808488;
  }

  .react-tabs__tab--selected {
    color: ${tabsTextColor} !important;
    border-bottom: 3px solid ${variables.colors.yellow1};
  }
`;

export const Payment = styled.div`
  font-weight: 600;
  color: ${itemTitleColor};

  .subtotal {
    display: ${displayFlex.display};
    padding: 14px;
    margin-bottom: 21px;
    justify-content: ${displayFlex.spaceBetween};
    background: ${itemAsideBackgroundColor};
    border-radius: 8px;
  }

  button {
    margin-bottom: 21px;
  }

  .footer {
    ${variables.fonts.overpassMonoRegular}
    text-align: center;
  }

  a {
    color: inherit;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const EmbedText = styled.p`
  font-family: 'Overpass Mono', monospace !important;
  font-weight: 400;
`;

export const TrailerWrapper = styled.div`
  height: 420px;
`;

export const TrailerButtons = styled.div`
  margin-top: 28px;
  display: flex;

  button {
    ${variables.fonts.openSansSemiBold};
    border: none;
    padding: 10px 14px;
    border-radius: 88px;
    background: ${itemAsideBackgroundColor};
    color: ${itemTextColor};
    cursor: pointer;
  }

  svg {
    margin-left: auto;
    fill: ${itemTextColor};
    cursor: pointer;
  }

  @media (max-width: 768px) {
    padding: 0px 14px;

    button {
      border: 1px solid ${itemTextColor};
    }
  }
`;
